import { routes } from '@sketch/modules-common'

export const authRoutes = {
  CHOOSE_YOUR_PATH: routes.CHOOSE_YOUR_PATH,
  FORGOT_PASSWORD: routes.FORGOT_PASSWORD,
  RESET_PASSWORD: routes.RESET_PASSWORD,
  SIGN_IN: routes.SIGN_IN,
  SIGN_UP: routes.SIGN_UP,
  SSO_ERROR: routes.SSO_ERROR,
  SSO_LINK_ACCOUNT: routes.SSO_LINK_ACCOUNT,
  SSO_SIGN_IN: routes.SSO_SIGN_IN,
  SSO_SUCCESSFUL_SIGN_IN: routes.SSO_SUCCESSFUL_SIGN_IN,
  SSO_TOS: routes.SSO_TOS,
}
export const allAuthRouteTemplates = Object.values(authRoutes).map(x =>
  x.template()
)
